import { ValueDisplay, ValueDisplayWithLabel } from '../../components/ValueDisplay'
import { useStyletron } from 'baseui';

import { IAnalogSetpoint } from './types'
import { LabelXSmall } from 'baseui/typography';
import { Block } from 'baseui/block';

export function SmallPanel(props: IAnalogSetpoint) {
    const [css, theme] = useStyletron();

    return (
        <Block display="flex" flexDirection={'column'} alignItems='center' alignContent='center'>
            <ValueDisplayWithLabel label={props.description} value={props.value} dimension={props.dimension} ></ValueDisplayWithLabel>
                </Block>
    );
}